import { RepaymentStrategy } from 'modules/cm/RepaymentStrategy/RepaymentStrategy';
import { NullableRecursive } from 'utils/types';

export enum FieldsLabels {
  HaveSaleOfPropertyAndDownsizing = 'Will the client sell or downsize from their current property?',
  HaveSaleOfAnotherProperty = 'Will the client sell another property?',
  HaveInvestments = 'Will the client sell investments?',
  HaveEndownments = 'Will the client use endowments?',
  HaveOther = 'Will the client use other means to repay the loan?',

  HowMuchOfTheLoanWillBeRepaid = 'How much of the loan will be repaid by this repayment method?',
  AddDetailsForOther = 'Add Details',

  TotalAmountToBeRepaid = 'Total amount to be repaid',
  RepaymentValueTotalCalculated = 'Repayment strategy total',

  FlatNumber = 'Flat Number',
  BuildingNumber = 'Building Number',
  BuildingName = 'Building Name',
  Street = 'Street',
  Postcode = 'Postcode',
  City = 'City',
  County = 'County',
  DateOfPurchase = 'Date of Purchase',
  PurchasePrice = 'Purchase Price',
  CurrentMortgageBalance = 'Current Mortgage Balance',

  Provider = 'Provider',
  ExpectedMaturityDate = 'Maturity Date',
  CurrentFundValue = 'Fund Value',
  MonthlyContribution = 'Monthly Contribution',
}

export interface RepaymentStrategyForm extends RepaymentStrategy {}

export interface Form extends NullableRecursive<RepaymentStrategyForm> {}
